import React from 'react';

import classnames from 'classnames';

import { CheckIconWithPadding, EvIcon } from '@evinced-private/ui-common';

import { OptionType } from '../../NavigationMenu';

import './NavigationMenuOption.scss';

interface NavigationMenuOptionProps {
	option: OptionType;
	index: number;
	isSelected: boolean;
	isFocused: boolean;
	onSelect: (option: OptionType) => void;
	onMouseEnter: (index: number) => void;
	listboxId: string;
}

export const NavigationMenuOption: React.FC<NavigationMenuOptionProps> = ({
	option,
	index,
	isSelected,
	isFocused,
	onSelect,
	onMouseEnter,
	listboxId
}) => {
	const handleClick = (e: React.MouseEvent): void => {
		e.preventDefault();
		onSelect(option);
	};

	const handleMouseEnter = (): void => {
		onMouseEnter(index);
	};

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events
		<li
			id={`${listboxId}-option-${index}`}
			role="option"
			aria-selected={isSelected}
			aria-current={isSelected ? 'page' : undefined}
			className={classnames('navigation-menu__option', {
				'navigation-menu__option--selected': isSelected,
				'navigation-menu__option--focused': isFocused
			})}
			onClick={handleClick}
			onMouseEnter={handleMouseEnter}
		>
			<div className="navigation-menu__option-link">
				<span className="navigation-menu__option-text">{option.label}</span>
				{isSelected && <EvIcon icon={CheckIconWithPadding} aria-hidden="true" small />}
			</div>
		</li>
	);
};
